import { useState } from "react";

import { SpaceCard } from "~/components/shared/Space";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "~/components/ui/";
import { cn } from "~/lib/utils";

export function Spaces({ spaces, onSpaceClick }) {

    const [selectedSort, setSelectedSort] = useState(SORT_OPTIONS[0]);

    const onlyFilteredSpaces = spaces.filter(({ isFiltered }) => isFiltered).sort(selectedSort.fn)
    // FIX: Messes up sort by price.
    // const onlyFilteredSpaces = spaces.filter(({ isFiltered }) => isFiltered).sort(selectedSort.fn).sort((a, b) => Number(a?.lotSpaceNbr) - Number(b?.lotSpaceNbr));


    let resultsString = `${spaces.length} result${spaces.length > 1 ? "s" : ""}`;

    if (onlyFilteredSpaces.length !== spaces.length) {
        resultsString = `${onlyFilteredSpaces.length} of ${resultsString}`;
    }

    return (
        <>
            <div className="flex justify-between items-center gap-2 flex-wrap">
                <div className="shrink-0">{resultsString}</div>
                <SortDropDown setSelectedSort={setSelectedSort} selectedSort={selectedSort} options={SORT_OPTIONS} />
            </div>
            <ul className={cn("grid gap-8 grid-cols-1 lg:grid-cols-2")}>
                {onlyFilteredSpaces.map((space) => {
                    return (
                        <li key={space.lotSellUnitId}>
                            <SpaceCard space={space} onClick={() => onSpaceClick(space)} />
                        </li>
                    );
                })}
                {onlyFilteredSpaces.length === 0 ? <h2>No spaces found.</h2> : null}
            </ul>
        </>
    );
}

export function SortDropDown({
    options,
    selectedSort,
    setSelectedSort,
}: {
    options: SortOptionProps[];
    selectedSort: SortOptionProps;
    setSelectedSort: (option: SortOptionProps) => void;
}) {
    return (
        <Select
            defaultValue={selectedSort.value}
            onValueChange={(value) => {
                setSelectedSort(options.find((option) => option.value === value));
            }}
        >
            <SelectTrigger className="w-[280px]" aria-label="Sort by">
                <SelectValue placeholder={selectedSort.name} />
            </SelectTrigger>
            <SelectContent>
                {options.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                        {option.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}

type SortOptionProps = {
    name: string;
    value: string;
    fn: (a: number, b: number) => number;
};

const SORT_OPTIONS = [
    // {
    //     name: "Sort by",
    //     value: "sort-by",
    //     fn: (a, b) => a.lotSpaceNbr - b.lotSpaceNbr,
    // },
    {
        name: "Sort by Price (low to high)",
        value: "low-to-high",
        fn: (a, b) => a.price - b.price,
    },
    {
        name: "Sort by Price (high to low)",
        value: "high-to-low",
        fn: (a, b) => b.price - a.price,
    },
];
